(function () {
	"use strict";

	angular.module("cardFrontConsumer.services", []);
}());
